module.exports = {
  // TODO: Define the list of languages for this project.
  languages: {
    en: 'English',
    de: 'Deutsch',
  },
  // TODO: Define the default language.
  defaultLanguage: 'en',
};
